import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-800 text-secondary-50">
      <div className="px-4 py-12 md:px-6 md:py-14">
        <div className="mx-auto flex max-w-6xl flex-col gap-10 md:flex-row md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-movie-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold">善良的小姨子在线</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200">
              专注热门电视剧在线观看与剧情追踪，为你整理最新剧集、剧情介绍与集数更新，让追剧变得简单。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            <div>
              <h4 className="mb-3 text-sm font-semibold text-secondary-50">
                <Link to="/category">浏览</Link>
              </h4>
              <ul className="space-y-2 text-sm text-secondary-200">
                <li><Link to="/category" className="hover:text-primary-300 transition-colors">电视剧分类</Link></li>
                <li><Link to="/search" className="hover:text-primary-300 transition-colors">搜索剧集</Link></li>
                <li><Link to="/" className="hover:text-primary-300 transition-colors">最新更新</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="mb-3 text-sm font-semibold text-secondary-50">
                <Link to="/about">关于</Link>
              </h4>
              <ul className="space-y-2 text-sm text-secondary-200">
                <li><Link to="/about" className="hover:text-primary-300 transition-colors">关于我们</Link></li>
                <li><Link to="/about" className="hover:text-primary-300 transition-colors">免责声明</Link></li>
                <li><Link to="/about" className="hover:text-primary-300 transition-colors">联系方式</Link></li>
              </ul>
            </div>
            <div className="col-span-2 sm:col-span-1">
              <h4 className="mb-3 text-sm font-semibold text-secondary-50">联系我们</h4>
              <ul className="space-y-2 text-sm text-secondary-200">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-300"></i>
                  hello@kind-sister.example
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-wechat-line text-primary-300"></i>
                  kind_sister_tv
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-10 flex max-w-6xl flex-col items-center justify-between gap-3 border-t border-secondary-700 pt-6 text-xs text-secondary-300 sm:flex-row">
          <p>© 2026 善良的小姨子在线 · 本站内容均为演示展示，不提供真实视频播放资源。</p>
          <p className="flex items-center gap-1">
            <i className="ri-information-line"></i>
            仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}